/**
 * @generated SignedSource<<6f02dca855d4f453c20fb3bcd4d7c0c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReleasedAtColumn_TreeNodeFragment$data = {
  readonly structureDefinition: {
    readonly firstReleasedAt?: string | null | undefined;
  };
  readonly " $fragmentType": "ReleasedAtColumn_TreeNodeFragment";
};
export type ReleasedAtColumn_TreeNodeFragment$key = {
  readonly " $data"?: ReleasedAtColumn_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReleasedAtColumn_TreeNodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReleasedAtColumn_TreeNodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "structureDefinition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstReleasedAt",
              "storageKey": null
            }
          ],
          "type": "RootStructureDefinition",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};

(node as any).hash = "85ba4f797241963b9896cc973603b703";

export default node;
